import UploadService from "../upload/UploadService";
import {_, _id} from "../util/dom";
import MediaLibrary from "../upload/MediaLibrary";
import Dropbox from "../components/Dropbox";
import UploadList from "../components/UploadList";
import MediaList from "../components/MediaList";
import HtmlTemplate from '../templating/HtmlTemplate';

function handleLibraryPage() {
    MediaLibrary.load('.media');

    const noMediaMessage = _id('no-files-messsage');
    const dropbox = $('.dropbox');
    const uploadList = $('.new-files');
    const mediaList = $('.existing-files tbody');

    const mediaTemplate = new HtmlTemplate(_id('media-template'));
    
    const service = new UploadService()
        .registerDropbox(new Dropbox(dropbox))
        .registerUploadList(new UploadList(uploadList))
        .registerMediaList(
            new MediaList(mediaList).registerTemplate(
                mediaTemplate, 
                (key, name, when) => [
                    name,
                    when,
                ]
            )
        )

    if(noMediaMessage) {
        service.on('success', key => noMediaMessage.classList.add('hide'));
    }
}


export default handleLibraryPage;